import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FiArrowRight } from 'react-icons/fi';
import DealerMap from '../components/DealerMap';

const Dealers = () => {
  return (
    <>
      <Helmet>
        <title>Find a Dealer Near You - ShedX Dealer Network</title>
        <meta name="description" content="Find an authorized ShedX dealer near you. Browse our growing network of shed dealers across Texas with free delivery and professional setup." />
      </Helmet>

      <div className="min-h-screen bg-gray-50 pt-24 pb-16">
        {/* Page Header */}
        <div className="bg-white border-b py-8">
          <div className="container mx-auto px-4">
            <h1 className="text-3xl font-bold text-gray-900 mb-1">Dealer Network</h1>
            <p className="text-gray-500">
              Find an authorized ShedX dealer near you
            </p>
          </div>
        </div>

        {/* Map */}
        <div className="container mx-auto px-4 py-8">
          <DealerMap className="shadow-sm" />
        </div>

        {/* Become a dealer CTA */}
        <div className="container mx-auto px-4 pb-8">
          <div className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 className="font-semibold text-gray-900 text-lg">Interested in becoming a dealer?</h2>
              <p className="text-gray-500 text-sm mt-1">
                Join the ShedX network and grow your shed business with our platform.
              </p>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-emerald-600 text-white px-6 py-2.5 rounded-md font-medium hover:bg-emerald-700 transition-colors flex-shrink-0"
            >
              Get in touch
              <FiArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dealers;
